import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import styles from "./style.module.css";
import CopyText from "../../components/copytext";
import List from "../../components/list";
import LogoutConfirmModal from "../../components/logout-confirm-modal";
import { DataContext, IDataContextValue } from "../../context/dataProvider";
import { useAuth } from "../../context/authContext";
import { usePlatform } from "../../hooks/usePlatform";

const links = [
  {
    label: "Политика конфиденциальности",
    value: "privacy-policy"
  },
  {
    label: "Пользовательское соглашение",
    value: "user-agreement"
  },
  {
    label: "Согласие",
    value: "agreement"
  },
  {
    label: "Оферта",
    value: "offer"
  }
];

function AccountPage() {
  const data: IDataContextValue | null = useContext(DataContext);
  const { user: authUser, logout } = useAuth();
  const { isTelegram } = usePlatform();
  const navigate = useNavigate();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const userServer = data?.user?.userServer;
  // Доступ отключён вручную при ещё действующей подписке — управление устройствами скрываем.
  const isDisabledAccess = Boolean(
    userServer && !userServer.isEnabled && new Date(userServer.subscriptionEndDate) >= new Date()
  );

  const listLinks = useMemo(() => {
    return [
      { label: "Способы входа", value: "/account/login-methods" },
      ...(userServer && !isDisabledAccess
        ? [{ label: "Управление устройствами", value: "/devices" }]
        : []),
      ...(data?.user?.orders && data.user.orders.length > 0 ? [{ label: "История покупок", value: "/history" }] : []),
    ];
  }, [userServer, isDisabledAccess, data?.user?.orders]);

  if (!authUser) {
    return null;
  }

  const handleLogoutClick = () => {
    if (isLoggingOut) return;
    setLogoutModalOpen(true);
  };

  const handleLogoutConfirm = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    try {
      await logout();
      setLogoutModalOpen(false);
      navigate("/login", { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className={styles.account}>
      <div className={styles.user}>
        <h1 style={{marginTop: isTelegram ? "0px" : "32px"}}>Мой профиль</h1>
        <p className={styles.userId}>
          <span className={styles.userIdLabel}>id:</span>
          <CopyText
            text={authUser.id}
            variant={"withoutBackground"}
            className={styles.userIdCopy}
          />
        </p>
      </div>
      <div className={styles.history}>
        <List
          list={listLinks}
        />
        { isTelegram ? null : (
        <button
          type="button"
          className={styles.logoutButton}
          onClick={handleLogoutClick}
          disabled={isLoggingOut}
        >
          Выйти
        </button>
        )}
      </div>
      <div className={styles.links}>
        {links.map((link) => (
          <p key={link.value}>
            <a href={link.value}>{link.label}</a>
          </p>
        ))}
      </div>

      <LogoutConfirmModal
        open={logoutModalOpen}
        onClose={() => setLogoutModalOpen(false)}
        onConfirm={() => void handleLogoutConfirm()}
        loading={isLoggingOut}
      />
    </div>
  );
}

export default AccountPage;